import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { ReviewService } from "../../services";
import { asQuery } from "../../services/common";
import { AD_STALE, DASH_STALE } from "./shared";

// A seller's aggregate review rating.
export function useSellerAggregate(sellerId?: string) {
  return useQuery({
    queryKey: ["reviews", "seller-aggregate", sellerId],
    queryFn: () =>
      asQuery<any>(ReviewService.getSellerAggregate(sellerId as string)),
    enabled: !!sellerId,
    staleTime: AD_STALE,
  });
}

// A seller's paginated public reviews (page/limit). keepPreviousData keeps the
// current page visible while the next loads.
export function useSellerPublicReviews(sellerId?: string, page = 0, limit = 5) {
  return useQuery({
    queryKey: ["reviews", "seller-public", sellerId, page, limit],
    queryFn: () =>
      asQuery<any>(
        ReviewService.getSellerPublicReviews(sellerId as string, page, limit),
      ),
    enabled: !!sellerId,
    staleTime: AD_STALE,
    placeholderData: keepPreviousData,
  });
}

// Reviews received about the signed-in seller (paginated dashboard list).
export function useMyReceivedReviews(
  token: string | undefined,
  page = 0,
  limit = 10,
) {
  return useQuery({
    queryKey: ["reviews", "mine-received", token, page, limit],
    queryFn: () =>
      asQuery<any>(
        ReviewService.getMyReceivedReviews(token as string, page, limit),
      ),
    enabled: !!token,
    staleTime: DASH_STALE,
    placeholderData: keepPreviousData,
  });
}

// Reviews the buyer can still write (no pagination; client-side filtered).
export function useBuyerReviews(token?: string) {
  return useQuery({
    queryKey: ["reviews", "buyer", token],
    queryFn: () => asQuery<any[]>(ReviewService.getForBuyer(token as string)),
    enabled: !!token,
    staleTime: DASH_STALE,
  });
}
